// Shared helpers for the activity-feed style message list (Messages.js,
// Messaging.js). Avatar color is role-based, not a per-name hash — reuses
// the app's own existing palette (green for the customer, the blue already
// used by .message-avatar/.message-count for Jain Farms/admin) instead of
// inventing a new one.
export const CUSTOMER_COLOR = "#2e7d32";
export const STAFF_COLOR = "#1976d2";

export function avatarColor(isStaff) {
  return isStaff ? STAFF_COLOR : CUSTOMER_COLOR;
}

export function avatarInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}

export function formatActivityDateLabel(iso) {
  const date = new Date(iso);
  const today = new Date();
  const isToday =
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate();
  return isToday ? "Today" : date.toLocaleDateString();
}

export function formatActivityTime(iso) {
  return new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}
